import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            {aboutInfo.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            了解蚂蚁影视背后的故事与愿景
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="space-y-5 md:space-y-6">
            {aboutInfo.paragraphs.map((para, idx) => (
              <p
                key={idx}
                className="text-sm md:text-base text-foreground-600 leading-relaxed"
              >
                {para}
              </p>
            ))}
          </div>

          <div className="mt-8 pt-8 border-t border-background-200/70">
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                  20,000+
                </div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">
                  500万+
                </div>
                <div className="text-xs text-foreground-500 mt-1">日活用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600 font-heading">
                  99.9%
                </div>
                <div className="text-xs text-foreground-500 mt-1">服务可用率</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                  50+
                </div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}